import { type ComponentProps, type ReactNode } from 'react';
import { VStack, Box } from '@terra/ui-styled-system';
import { Text } from '../../components/text';

type EmptyStateProps = {
  title: string;
  description?: string;
  icon?: ReactNode;
  children?: ReactNode;
  maxWidth?: ComponentProps<typeof VStack>['maxW'];
};

export const EmptyState = ({
  title,
  description,
  icon,
  children,
  maxWidth = 'md',
}: EmptyStateProps) => (
  <VStack
    alignItems="center"
    justifyContent="center"
    w="full"
    h="full"
    maxW={maxWidth}
    gap={0}
    py={8}
    mx="auto"
  >
    {icon && (
      <Box
        color="fg.neutral.disabled"
        w={16}
        h={16}
        mb={6}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {icon}
      </Box>
    )}

    <Text fontSize="md" fontWeight="medium" textAlign="center" mb={2}>
      {title}
    </Text>

    {description && (
      <Text color="fg.muted" fontSize="md" textAlign="center" mb={6}>
        {description}
      </Text>
    )}

    {children}
  </VStack>
);
